// store portal target to be used by any component that needs to render an overlayed element

import { createContext, ReactNode, useRef } from 'react';

export type OverlayContext = {
  setElement: (el: HTMLDivElement) => void
  getElement: () => HTMLDivElement | null
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OverlayContext = createContext<OverlayContext>({
  setElement: () => {},
  getElement: () => null,
});

interface OverlayProviderProps {
  children: ReactNode
}

export function OverlayProvider(props: OverlayProviderProps) {
  const { children } = props;

  const overlayElement = useRef<HTMLDivElement | null>(null);
  const overlayContextValue = useRef<OverlayContext>({
    setElement: (el) => {
      overlayElement.current = el;
    },
    getElement: () => overlayElement.current,
  });

  return (
    <OverlayContext.Provider value={overlayContextValue.current}>
      {children}
    </OverlayContext.Provider>
  );
}
